module.exports = __webpack_public_path__ + "img/cisco-4.5c19e526.jpg";